import { all, fork } from 'redux-saga/effects';

import watchGetProduct from './getProduct';
import watchNotifyMeRequest from './notifyMeRequest';
import watchProductPersonalizedRequest from './productPersonalizedRequest';
import watchSendSpecialistContact from './sendSpecialistContact';
import watchSetProductBuyTogether from './setProductBuyTogether';

function* productSagas() {
  yield all([
    fork(watchGetProduct),
    fork(watchProductPersonalizedRequest),
    fork(watchSetProductBuyTogether),
    fork(watchNotifyMeRequest),
    fork(watchSendSpecialistContact),
  ]);
}

export default productSagas;
